export const zIndexes = {
  navigation: 3,
  overlay: 4,
}
